var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgExpandBtnPen(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 36,
    viewBox: "0 0 37 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.214233,
    width: 36,
    height: 36,
    rx: 6,
    fill: "#206DC5"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.9999 23.8318L25.1109 24.8043C24.6394 25.3199 24 25.6096 23.3333 25.6096C22.6667 25.6096 22.0273 25.3199 21.5558 24.8043C21.0836 24.2897 20.4443 24.0008 19.7778 24.0008C19.1113 24.0008 18.472 24.2897 17.9999 24.8043M9.99988 25.6096H11.4884C11.9232 25.6096 12.1406 25.6096 12.3452 25.5605C12.5266 25.5169 12.7 25.4451 12.8591 25.3476C13.0385 25.2377 13.1922 25.0839 13.4997 24.7765L24.6666 13.6096C25.403 12.8732 25.403 11.6793 24.6666 10.9429C23.9302 10.2065 22.7363 10.2065 21.9999 10.9429L10.833 22.1098C10.5255 22.4173 10.3718 22.571 10.2619 22.7504C10.1644 22.9095 10.0925 23.0829 10.049 23.2643C9.99988 23.4689 9.99988 23.6863 9.99988 24.1211V25.6096Z",
    stroke: "#FCFCFD",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExpandBtnPen);
export default __webpack_public_path__ + "static/media/expandBtnPen.f096e529bc7dbb1ae0177177cb5e06f9.svg";
export { ForwardRef as ReactComponent };